export const COGNITO_CONFIG = {
    domain: "ris-task-test.auth.ap-south-1.amazoncognito.com",
    clientId: "7470o8fubbqq6okenoqcljnhg8",
    userPoolId: "ap-south-1_daBWTmaq6",
    redirectUri: "http://localhost:3000",
    region: "ap-south-1",
    apiBaseUrl: "https://ugnqtik7ph.execute-api.ap-south-1.amazonaws.com"
};

export const getLoginUrl = () => {
    return `https://${COGNITO_CONFIG.domain}/login?client_id=${COGNITO_CONFIG.clientId}&response_type=code&scope=openid+email+phone&redirect_uri=${encodeURIComponent(COGNITO_CONFIG.redirectUri)}`;
};

export const getLogoutUrl = () => {
    return `https://${COGNITO_CONFIG.domain}/logout?client_id=${COGNITO_CONFIG.clientId}&logout_uri=${encodeURIComponent(COGNITO_CONFIG.redirectUri)}`;
};
